<template>
  <div class="loading">
    <van-skeleton title :row="15" style="padding-top: 15px; padding-bottom: 15px;" />
  </div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style lang="scss" scoped>
  .loading {
    background: white;
  }
</style>
